import gql from "graphql-tag";
import AssetDiscussionCommentFields from "../../fragments/AssetDiscussionCommentFields";

export default gql`
  mutation EditAssetDiscussionComment($commentId: ObjectID!, $bodyAsPlainText: String!) {
    editAssetDiscussionComment(commentId: $commentId, bodyAsPlainText: $bodyAsPlainText) {
      __typename
      ...AssetDiscussionCommentFields
    }
  }

  ${AssetDiscussionCommentFields}
`;
